<template>
  <d-container fluid class="main-content-container p-4">
    <d-modal v-if="modalVisible" @close="onModalClose">
      <d-modal-header>
        <d-modal-title>Identifiants temporaires</d-modal-title>
      </d-modal-header>
      <d-modal-body>
        <p class="text-info text-center">
          <i class="fa fa-info-circle"></i> Les identifiants temporaires de l'utilisateur ont été envoyés par email
          à l'adresse {{ email }}
        </p>
        <d-form-row>
          <d-col>
            <b-form-group>
              <label class="font-weight-bold mb-0">Nom d'utilisateur</label>
              <d-input-group>
                <d-input-group-addon class="flex-fill" prepend>
                  <c-input class="flex-fill" :value="username" ref="usernameReadOnly" disabled/>
                </d-input-group-addon>
                <d-input-group-addon append>
                  <b-button variant="success" @click="onUsernameCopy">
                    <i class="fa fa-copy"></i> Copier
                  </b-button>
                </d-input-group-addon>
              </d-input-group>
            </b-form-group>
            <b-form-group>
              <label class="font-weight-bold mb-0">Mot de passe</label>
              <d-input-group>
                <d-input-group-addon class="flex-fill" prepend>
                  <c-input class="flex-fill" :value="password" ref="passwordReadOnly" disabled/>
                </d-input-group-addon>
                <d-input-group-addon append>
                  <b-button variant="success" @click="onPasswordCopy" disabled>
                    <i class="fa fa-copy"></i> Copier
                  </b-button>
                </d-input-group-addon>
              </d-input-group>
            </b-form-group>
          </d-col>
        </d-form-row>
      </d-modal-body>
      <d-modal-footer class="justify-content-center">
        <b-button variant="secondary" @click="onModalClose" class="ml-2">
          <i class="fa fa-times"></i> Fermer
        </b-button>
      </d-modal-footer>
    </d-modal>
    <d-card class="card-small">
      <d-card-header><h3 class="text-center">Nouveau compte</h3></d-card-header>
      <d-card-body>
        <d-form-row>
          <d-col class="pr-3 border-right">
            <c-input type="select" label="Type de compte" :options="accountTypeOptions" v-model="accountType"/>
            <c-input v-show="isCorporateAccount" label="Nom de l'administration (ou entreprise)"
                     placeholder="Ex: Ministère des postes et télécommunications"
                     v-model="corporateName" :state="corporateNameState">
              Veuillez saisir un nom
            </c-input>
            <c-input type="tel" label="Numéro de téléphone" placeholder="Ex: 699009900"
                     v-model="phoneNumber" :state="phoneNumberState">
              Veuillez saisir un numéro de téléphone
            </c-input>
            <c-input label="Adresse email" placeholder="Ex: bob@campostpayment.com"
                     v-model="email" :state="emailState">
              Veuillez saisir une adresse email
            </c-input>
          </d-col>
          <d-col class="ml-2">
            <c-input type="select" label="Genre" :options="genderOptions" v-model="gender"/>
            <c-input label="Nom(s)" placeholder="Ex: MARLEY" v-model="lastName" :state="lastNameState">
              Veuillez saisir un nom
            </c-input>
            <c-input label="Prénoms(s)" placeholder="Ex: Bob" v-model="firstName" :state="firstNameState">
              Veuillez saisir un prénom
            </c-input>
            <c-input type="date" label="Date de naissance" v-model="birthdate" :state="birthdateState">
              Veuillez entrer une date de naissance
            </c-input>
            <c-input label="Nom d'utilisateur (login)" placeholder="Ex: bob123"
                     v-model="username" :state="usernameState">
              Veuillez saisir un nom d'utilisateur
            </c-input>
          </d-col>
        </d-form-row>
      </d-card-body>
      <d-card-footer>
        <d-input-group class="justify-content-center">
          <c-button-spinner class="inline-btn mr-1" variant="secondary" @click="onModalClose">
            <template slot="icon"><i class="fa fa-trash"></i></template>
            Tout effacer
          </c-button-spinner>
          <c-button-spinner class="inline-btn" variant="primary" :fetching="fetching" @click="onSubmit">
            <template slot="icon"><i class="fa fa-save"></i></template>
            Enregistrer
          </c-button-spinner>
        </d-input-group>
      </d-card-footer>
    </d-card>
  </d-container>
</template>

<script>
import {Api, Regex, Toast} from "@/helpers"

export default {
  title: "Nouveau compte",
  data() {
    return {
      fetching: false,
      submitted: false,

      modalVisible: false,

      accountType: "PERSONAL",
      corporateName: "",
      gender: "M",
      lastName: "",
      firstName: "",
      birthdate: null,
      phoneNumber: "",
      email: "",
      username: "",

      password: "**********",
    }
  },
  computed: {
    accountTypeOptions() {
      return [
        {text: "Particulier", value: "PERSONAL"},
        {text: "Administration / Entreprise", value: "CORPORATE"}
      ]
    },
    genderOptions() {
      return [{text: "Homme", value: "M"}, {text: "Femme", value: "F"}]
    },
    isCorporateAccount() {
      return this.accountType === "CORPORATE"
    },
    corporateNameState() {
      return !this.submitted || !this.isCorporateAccount || this.corporateName.length >= 2
    },
    lastNameState() {
      return !this.submitted || this.lastName.length >= 2
    },
    firstNameState() {
      return !this.submitted || this.firstName.length >= 2
    },
    birthdateState() {
      return !this.submitted || Regex.isDate(this.birthdate)
    },
    phoneNumberState() {
      return !this.submitted || Regex.isPhoneNumber(this.phoneNumber)
    },
    emailState() {
      return !this.submitted || Regex.isEmail(this.email)
    },
    usernameState() {
      return !this.submitted || this.username.match(/^\w{3,}$/)
    },
  },
  methods: {
    isFormValid() {
      return this.corporateNameState
        && this.lastNameState && this.firstNameState && this.birthdateState
        && this.phoneNumberState && this.emailState && this.usernameState
    },
    onModalClose() {
      this.modalVisible = false
      this.submitted = false
      this.accountType = "PERSONAL"
      this.corporateName = ""
      this.gender = "M"
      this.lastName = ""
      this.firstName = ""
      this.birthdate = null
      this.phoneNumber = ""
      this.email = ""
      this.username = ""
      this.password = ""
    },
    onSubmit() {
      this.submitted = true

      if (!this.isFormValid()) return

      this.fetching = true
      Api.post("/user/create", {
        accountType: this.accountType,
        corporateName: this.corporateName,
        gender: this.gender,
        lastName: this.lastName,
        firstName: this.firstName,
        birthdate: this.birthdate,
        phoneNumber: this.phoneNumber,
        email: this.email,
        username: this.username,
      })
        .then(res => {
          const {user} = res.data
          if (user) {
            Toast.success(`Le compte ${user.last_name} ${user.first_name} a été créé avec succès`)
            this.modalVisible = true
          } else {
            Toast.error("Une erreur est survenue lors de la création du compte")
          }
        })
        .catch(err => this.error = err)
        .then(() => {
          this.fetching = false
          this.submitted = false
        })
    },
    onUsernameCopy() {
      navigator.clipboard.writeText(this.username)
      Toast.success("Nom d'utilisateur copié avec succès")
    },
    onPasswordCopy() {
      navigator.clipboard.writeText(this.password)
      Toast.success("Mot de passe copié avec succès")
    },
  }
}
</script>

<style scoped>
</style>
